// Settings Constants
export const SETTINGS_URL = `/api/settings`;
export const GET_SETTINGS = `${SETTINGS_URL}/get_settings`;
export const SET_SETTINGS = `${SETTINGS_URL}/set_settings`;
